<!--
 * @Author: zhanglei
 * @Date: 2022-11-10 18:11:21
 * @LastEditors: zhanglei
 * @LastEditTime: 2023-03-16 12:02:43
 * @Description: 转载文章声明组件
-->
<template>
    <div v-show="isShow" class="transfer-container">
        <span class="transfer-mark">转载自原创文章：</span>
        <a :href="transferInfo.articleUrl" class="transfer-link" target="_blank">
            <span class="transfer-title">《{{transferInfo.title | interceptStr}}》</span>
        </a>
    </div>
</template>
<script>

export default {
    name:'transfer-article',
    props:{
        //原创文章id
        originalId: {
            type: String,
            default: 0
        }
    },
    data: function() {
            return {
                transferInfo:{},
                isShow:false
            }
        },
        methods: {
            /*
            ** 从接口中获取转载文章信息
            */
            getTransferList(callback) {
                if(typeof callback === 'function') {
                    const url = `//v2.sohu.com/article-service-api/article/${this.originalId}/lite`
                     $.ajax({
                        url: url,
                        type: "GET",
                        dataType: "json",
                        xhrFields: {
                            withCredentials: true
                        },
                        success: (data) => {
                            callback(data)
                        },
                        error: (err) => {
                            console.log(err);
                        }
                    })
                }
            },
            getTransfer() {
                var self = this;
                this.getTransferList(function(data){
                    if(data.code === 200){
                        self.isShow = true
                        self.transferInfo = data.data
                    }else{
                        self.isShow = false
                    }
                });
            }
        },
        mounted(){
            this.getTransfer();
        },
        filters: {
            interceptStr: function(value) {
                if (!value) return ''
                if(value.length > 32){
                    value = value.substring(0,32) + '...'
                }
                return value
            }
        }
}
</script>
<style lang="less" scoped>
.transfer-container {
    background: #F2F2F2;
    padding: 21px 30px 22px 25px;
    margin-bottom: 40px;
    span {
        line-height: 38px;
    }
    span.transfer-mark {
        font-size: 24px !important;/*px*/
        color: #191919;
    }
    .transfer-link{
        color: #539FF3;
        text-decoration: none;
        .transfer-title {
            font-size: 24px !important;/*px*/
        }
    }
}
</style>